export default {
  LANGUAGE_COOKIE: 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE',
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  HOME: 'HOME',
  STORE: 'STORE',
  TUTORS: 'TUTORS',
  MY_COURSES: 'MY_COURSES',
  MY_CLASSES: 'MY_CLASSES',
  CLASSES: 'CLASSES',
  SHARE_WITH_ME: 'SHARE_WITH_ME',
  SUBJECTS: 'SUBJECTS',
  PURCHASED: 'PURCHASED',
  COURSE_CREATION: 'COURSE_CREATION',
  CONTENT_CREATION: 'CONTENT_CREATION',
  VIEW_SELECTION: {
    GRID_VIEW: 'gridView',
    LIST_VIEW: 'listView'
  },
  PREFERENCES: {
    VIEWSELECTION: 'VIEWSELECTION'
  },
  COOKIES: {
    VIEW_SELECTION_COOKIE: 'EDUAC-VIEWSELECTION'
  },
  CSS: {
    EDG_SHIMMER_CONTAINER: 'edg-shimmer-container',
    EDG_FLEX_WRAP_WRAP: 'edg-flex-wrap--wrap',
    EDG_FLEX_DIR_COLUMN: 'edg-flex-dir--column'
  },
  CONTENT_TYPE: {
    BOOK: 'BK',
    COURSE: 'CS',
    CS: 'COURSE',
    BK: 'BOOK',
    COURSE_TEMPLATE: 'CST',
    CST: 'COURSE_TEMPLATE',
    OTHERS: 'OTHERS',
    COURSE_QUICK: 'CSQ',
    CSQ: 'COURSE_QUICK',
  },
  LINK_TYPE: {
    URL: 'URL',
    ROUTE: 'ROUTE'
  },
  ROLES: {
    PUBLISHER: 'PUBLISHER',
    BUYER: 'BUYER'
  },
  TINY_API_KEY: '7j8pgmjiztl74oaktxzitkzj9v4pys27gcyjn2sydty1r7at',
  DROPZONE_CONFIG: {
    MULTIPLE: 'MULTIPLE',
    SINGLE: 'SINGLE'
  },
  DOCS_VIEWER: 'https://view.officeapps.live.com/op/embed.aspx?src=',
  FILES_TYPE: {
    PDF: 'PDF',
    DOCX: 'DOCX',
    DOC: 'DOC',
    XLSX: 'XLSX',
    XLS: 'XLS',
    PPTX: 'PPTX',
    PPT: 'PPT',
    EPUB: 'EPUB',
    ZIP: 'ZIP'
  },
  MIMETYPES: {
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    DOC: 'application/msword',
    PDF: 'application/pdf',
    EPUB: 'application/epub+zip'
  },
  CONTEXT: '/eduac',
  EVENT_TYPES: {
    SUCCESS: 'success',
    DANGER: 'danger',
    WARNING: 'warning'
  },
  JSON_HEADERS:{
    'Content-Type': 'application/json;charset=UTF-8',
    'dataType': 'json'
  },
  UTC_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSS',
  OBJECT_TYPES: {
    OBJECT: 'object'
  },
  INPUT_MODES: {
    LINE: 'LINE',
    BLOCK: 'BLOCK'
  },
  LANGUAGES: {
    ES: 'es',
    EN: 'en'
  },
  LANGUAGES_LABEL: {
    ES: 'ES',
    EN: 'US'
  },
  PRE_OBJECT_ID: 'ED_SECTION_OBJECT_',
  PRE_SECTION_ID: 'ED_SECTION_TITLE_',
  PRE_PROJECT_ID: 'ED_PROJECT_TITLE_',
  PRE_PROJECT_OBJECT_ID: 'ED_PROJECT_OBJECT_',
  ED_RESUME_TREE_ID: 'EdLessonResumeTree',
  ROLES_MAPPED: {
    PUBLISHER: 'TEACHER',
    BUYER: 'STUDENT'
  },
  FILE_EXTENSIONS_ALLOWED: 
    ['.pdf', '.docx', '.doc', '.xlsx', '.xls', '.pptx', '.ppt', '.mp3', '.wav', '.jpg', '.png', '.jpeg', '.mp4']
};